/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type {
  WethLoanRouter,
  WethLoanRouterInterface,
} from "../WethLoanRouter";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ILoanRouter",
        name: "_loanRouter",
        type: "address",
      },
      {
        internalType: "contract IWETH9",
        name: "_weth",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "loanRouter",
    outputs: [
      {
        internalType: "contract ILoanRouter",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "weth",
    outputs: [
      {
        internalType: "contract IWETH9",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IBondController",
        name: "bond",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "sales",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "minOutput",
        type: "uint256",
      },
    ],
    name: "wrapAndBorrow",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IBondController",
        name: "bond",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minOutput",
        type: "uint256",
      },
    ],
    name: "wrapAndBorrowMax",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
];

const _bytecode =
  "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";

type WethLoanRouterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: WethLoanRouterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class WethLoanRouter__factory extends ContractFactory {
  constructor(...args: WethLoanRouterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _loanRouter: PromiseOrValue<string>,
    _weth: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<WethLoanRouter> {
    return super.deploy(
      _loanRouter,
      _weth,
      overrides || {}
    ) as Promise<WethLoanRouter>;
  }
  override getDeployTransaction(
    _loanRouter: PromiseOrValue<string>,
    _weth: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_loanRouter, _weth, overrides || {});
  }
  override attach(address: string): WethLoanRouter {
    return super.attach(address) as WethLoanRouter;
  }
  override connect(signer: Signer): WethLoanRouter__factory {
    return super.connect(signer) as WethLoanRouter__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): WethLoanRouterInterface {
    return new utils.Interface(_abi) as WethLoanRouterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): WethLoanRouter {
    return new Contract(address, _abi, signerOrProvider) as WethLoanRouter;
  }
}
